import React from "react"
import {observer} from "mobx-react"
import {FormattedMessage} from "react-intl"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import renderHTML from "react-render-html"
import "./xsDialog.less"

import XsButton from "../xsButton/xsButton"

import InformationStore from "../../store/InformationStore"

@observer
export default class XsInformationDialog extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<Dialog
				aria-describedby="info-dialog-description"
				open={InformationStore.isOpen}
				onEscapeKeyDown={() => InformationStore.close()}
				maxWidth="md"
				className="xs-info-dialog"
			>
				<DialogTitle className="xs-info">
					<div className="xs-header">
						<div className="xs-header-icon">
							<i className="fal fa-info fa-2x" />
						</div>
						<div className="xs-header-title">{<FormattedMessage id="Common.form.info" />}</div>
					</div>
				</DialogTitle>
				<DialogContent className="xs-content">
					{isEmpty(InformationStore.message) ? "" : renderHTML(InformationStore.message)}
				</DialogContent>
				<DialogActions className="xs-footer">
					<XsButton
						className="xs-info"
						text={<FormattedMessage id="Common.label.ok" />}
						onClick={() => InformationStore.close()}
					/>
				</DialogActions>
			</Dialog>
		)
	}
}
